import React from 'react';
import { useIntl } from 'react-intl';

import RadioButton, { RadioButtonGroup, RadioButtonGroupProps } from 'carbon-react/lib/components/radio-button';

import { ForecastFormElementIds, ForecastTypeOption } from '../../types';

export interface ForecastTypeProps extends Omit<RadioButtonGroupProps, 'name' | 'id' | 'legend' | 'children'> {
  fixedContent?: React.ReactNode;
  rollingContent?: React.ReactNode;
}

export const ForecastType = ({ fixedContent, rollingContent, ...props }: ForecastTypeProps) => {
  const intl = useIntl();
  return (
    <RadioButtonGroup
      legend={intl.formatMessage({
        id: 'predict.create_forecast.outstanding_receivables_and_payables_question',
        defaultMessage: 'How should outstanding receivables and payables be treated in this 3-way forecast?'
      })}
      name={ForecastFormElementIds.Type}
      id={ForecastFormElementIds.Type}
      required
      {...props}
    >
      <RadioButton
        id={`radio-forecast-type-${ForecastTypeOption.Fixed}`}
        value={ForecastTypeOption.Fixed}
        label={intl.formatMessage({
          id: 'predict.create_forecast.pay_down_manually',
          defaultMessage: 'Pay down manually'
        })}
        inputHint={intl.formatMessage({
          id:
            'predict.create_forecast.pay_down_manually.apply_a_payment_rule_to_the_outstanding_balance_with_a_prediction',
          defaultMessage: 'Apply a payment rule to the outstanding balance with a prediction'
        })}
        progressiveDisclosure={fixedContent}
      />
      <RadioButton
        id={`radio-forecast-type-${ForecastTypeOption.Rolling}`}
        value={ForecastTypeOption.Rolling}
        label={intl.formatMessage({
          id: 'predict.create_forecast.use_individual_due_invoices',
          defaultMessage: 'Use individual due invoices'
        })}
        inputHint={intl.formatMessage({
          id: 'predict.create_forecast.use_individual_due_invoices.use_or_override_existing_payment_terms',
          defaultMessage: 'Use or override existing payment terms'
        })}
        progressiveDisclosure={rollingContent}
      />
    </RadioButtonGroup>
  );
};
